import assetsLinks from './assetsLinks';

export default assetsLinks;
